import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function FigsByCategory() {
  const [categories, setCategories] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      .get(API_URL + "categories")
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.error("Failed to load categories", err);
      });
  }, []);

  return (
    <div className="container my-5">
      <h2 className="text-left mb-4 section-heading">
        All Categories
      </h2>

      <div className="row justify-content-center">
        {categories.length === 0 && (
          <p className="text-center">No categories found</p>
        )}

        {categories.map((cat) => (
          <div
            key={cat.id}
            className="col-lg-2 col-md-2 col-sm-6 mb-4 d-flex flex-column align-items-center"
          >
            <Link
              to={`/categories/${cat.slug}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="img-fluid"
                style={{ borderRadius: "6px", cursor: "pointer" }}
                onError={(e) => {
                  e.target.src = "/images/placeholder.png";
                }}
              />
              <p className="mt-2 text-center fw-semibold">
                {cat.name}
              </p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
